import React from "react";
import { motion } from "framer-motion";
import { AlertTriangleIcon } from "lucide-react";
import { PAIN_POINTS } from "../lib/data";
export function PainPoints() {
  return <section className="px-4 pt-12" data-id="element-137" data-mp="26ypit95htotx">
      <div className="mx-auto max-w-md" data-id="element-138" data-mp="26xecp2oks4zn">
        <h2 className="font-display text-2xl font-extrabold leading-tight text-slate-900" data-id="element-139" data-mp="26wlggvn8sxvr">
          Si eres fisio de verdad, sabes lo que es el papeleo post consultorio
        </h2>
        <p className="mt-2 text-sm text-slate-500" data-id="element-140" data-mp="1xwg9unpvi3in">
          Fisioterapeutas quemados de pasar horas cada semana escribiendo informes,
          cargando planillas y armando casos clínicos:
        </p>

        <ul className="mt-5 space-y-3" data-id="element-141" data-mp="1o1oc9jwajgnv">
          {PAIN_POINTS.map((p, i) => <motion.li key={i} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: "-40px"
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="flex items-start gap-3 rounded-2xl border border-red-100 bg-red-50/60 p-3.5" data-id="element-142" data-mp="1sz6lzci4tzwx" data-mpi={i}>
              <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-143" data-mp="1u0ix300pfmsx" />
              <span className="text-[14px] font-medium leading-snug text-slate-700" data-id="element-144" data-mp="27tidd48b9l1j">
                {p}
              </span>
            </motion.li>)}
        </ul>

        <div className="mt-6 rounded-2xl bg-slate-900 p-5 text-center" data-id="element-145" data-mp="1g1sz7i629j3i">
          <p className="font-display text-lg font-extrabold text-white" data-id="element-146" data-mp="1g22pz7yxjua9">
            Para eso hicimos el{" "}
            <span className="text-teal-300" data-id="element-147" data-mp="1b4spmxa05y7n">Megapack Fisio Eficiente</span>
          </p>
        </div>
      </div>
    </section>;
}